import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class CampaignJobViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.CAMPAIGN_JOB_VIEW = '/api/campaign-job-view';

        this.GET_LIST_FILTERED = '/list/filtered';
        this.REPORT_EXPORT = '/generate-report';
    }

    async getListFiltered(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.CAMPAIGN_JOB_VIEW + this.GET_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async exportReport(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.CAMPAIGN_JOB_VIEW + this.REPORT_EXPORT;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default CampaignJobViewService;
